import React, { useEffect, useState } from 'react';
import EcomCard from '../EcomCard';
import styled from 'styled-components';
import {
	getCurrencySymbol,
	loadStateSession,
	saveStateSession,
} from '../../../../FlyfishComponents/flyfishutils/utils';
import Axios from 'axios';
import EcomCartItem from '../EcomCartItem';
import MessageFeedback from '../../../../FeatureComponents/MessageFeedback';

type Props = {
	message: string;
	metaData: any;
	token: string;
	tenantId: string;
	botId: string | number;
	time: string;
	showBack: Function;
	showCartData: Function;
	showCart: boolean;
	reasonAPIPayload;
	secondAPI;
	responseId;
	colorMode: string;
	setSelectedProductData;
	handleStyleAdvisor: Function;
	styleAdvisor;
	styleAdvisorCache;
	getTitleMessage;
	handleSubmit;
	conversationId: number;
	queryText: string;
	categoriesProductsArray: any;
	setTopProductsRowsCounter: any;
	openThumbsPopup;
	thumbFilledUp;
	popUpSnackBar;
	messageId;
	storeStyle;
	enableStyleAdvisor;
	advisorTitle,
	staticDetailsURL,
	onClose,
	topProductID
	//topProductIds
};

const EcomChatDiv = styled.div`
	font-family: var(--fontFamily);
	&.ff-ecom-cart-chat {
		& > .ecom-product-list {
			overflow: hidden !important;
			height: unset;
			
			& > .side-filter {
				width: 350px;
				background: #fff;
				border-right: 1px solid #c6c4c4;
				&.side-filter-mobile {
					width: 100%;
					position: fixed;
					z-index: 9999;
					display: none;
					top: 86px;
					&.show {
						display: flex;
					}
					> div {
						&:nth-of-type(1) {
							width: 100%;
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 800px) {
		& > .filter-message-time-holder {
			& > .message-time {
				width: 86vw !important;
				display: block !important;
				margin-left: 35px !important;
				margin-right: 0 !important;
				& > .time {
					text-align: right;
					margin-top: 16px;
				}
				& > .ff-ecom-feedback {
					& > .sf-message-feedback {
						margin-right: 12px;
					}
				}
			}
		}
	}

	& > .filter-message-time-holder {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		background-color: #f7f7f7;
		border-bottom: 1px solid #c6c4c4;
		padding: 6px 0;
		position: relative;
		& > .back-button {
			display: flex;
			align-items: center;
			position: absolute;
			left: 15px;
			cursor: pointer;
			& > svg {
				margin-right: 9px;
			}
			& > div {
				color: #111111;
			}
		}

		& > .message-time {
			width: 70vw;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-right: 35px;
			font-family: var(--fontFamily);
			& > .ff-ecom-feedback {
				& > .sf-message-feedback {
					margin-right: 20px;
					& .sf-time-wrapper {
						padding: unset !important;
						padding-left: 2px !important;
						&.server {
							margin-left: unset !important;
							margin-top: unset !important;
						}
					}
				}
			}
			& > .message {
				width: fit-content;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				overflow: hidden;
				margin-right: 24px;
				font-size: 16px;
				font-weight: 500;
			}
			& > .time {
				color: #363636;
				opacity: 0.5;
				font-size: 12px;
				white-space: nowrap;
				margin-right: 10px;
			}
		}
	}

	& > .ecom-product-list {
		overflow: auto;
		height: calc(100vh - 120px);
		width: 100%;
		padding-top: 38px;
		display: flex;
		flex-direction: column;
		align-items: center;
		@media (max-width: 820px) {
			height: calc(100vh - 210px);
		}
		& > .list-of-products {
		
			padding-bottom: 66px;
			& > .category {
				margin: 20px 0;
				& > p {
					font-size: 20px;
					color: ${(props) =>
		props.colorMode === 'dark' ? '#171615' : 'var(--colorScale-0)'};
					text-transform: uppercase;
					letter-spacing: 0.8px;
					font-family: var(--fontFamily);
					border-bottom: 2px solid
						${(props) =>
		props.colorMode === 'dark' ? '#171615' : 'var(--colorScale-0)'};
					padding-bottom: 6px;
					font-weight: bold;
				}
			}
			& > .product-row {
				display: flex;
				// justify-content: center;
				gap: 10px;
				margin-bottom: 20px;
				& > .product {
					display: flex;
					max-width: 215px;
					min-width: 215px;
					@media (max-width: 430px) {
						min-width: 50%;
					}
					&.selected {
						border: 1px solid
							${(props) =>
		props.colorMode === 'dark'
			? 'var(--colorScale-3)'
			: 'var(--colorScale-0)'};
						border-radius: 11px;
					}
				}
			}
			& > .view-products {
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 16px;
				& > .show-more,
				& > .show-less {
					display: flex;
					align-items: center;
					font-size: 12px;
					gap: 10px;
					font-family: var(--fontFamily);
					cursor: pointer;
					& > p {
						width: fit-content;
					}
				}
				& > .show-more {
					color: ${(props) =>
		props.colorMode === 'dark'
			? 'var(--colorScale-3)'
			: 'var(--colorScale-0)'};
					& > svg {
						stroke: ${(props) =>
		props.colorMode === 'dark'
			? 'var(--colorScale-3)'
			: 'var(--colorScale-0)'};
					}
				}
				& > .show-less {
					& > svg {
						stroke: ${(props) =>
		props.colorMode === 'dark'
			? 'var(--colorScale-3)'
			: 'var(--colorScale-0)'};
					}
					color: ${(props) =>
		props.colorMode === 'dark'
			? 'var(--colorScale-3)'
			: 'var(--colorScale-0)'};
				}
			}
		}
	}
`;
const EcomChats = ({
	message,
	metaData,
	token,
	tenantId,
	botId,
	time,
	showBack,
	showCartData,
	showCart,
	reasonAPIPayload,
	responseId,
	secondAPI,
	colorMode,
	setSelectedProductData,
	handleStyleAdvisor,
	styleAdvisor,
	styleAdvisorCache,
	getTitleMessage,
	queryText,
	handleSubmit,
	conversationId,
	categoriesProductsArray,
	setTopProductsRowsCounter,
	openThumbsPopup,
	thumbFilledUp,
	popUpSnackBar,
	messageId,
	storeStyle,
	enableStyleAdvisor,
	advisorTitle,
	staticDetailsURL,
	onClose,
	topProductID
}: Props) => {
	const [ecomCategories, setEcomCategories] = useState(
		metaData && metaData.categories
	);
	const [reasonData, setReasonData] = useState<any>();
	const [selectedProduct, setSelectedProduct] = useState(null);
	const [productsPerRow, setProductsPerRow] = useState(4);
	const [selectedProductID, setSelectedProductID] = useState(4);
	const [categoriesArray, setCategoriesArray] = useState<any>([
		{
			category: metaData && metaData.categories && metaData.categories[0],
			products: metaData && metaData.products,
			rows: 1,
		},
	]);
	const [categoriesLLMArray, setCategoriesLLMArray] = useState<any>([]);
	const [category, setCategory] = useState('');
	const [quantityUpdated, setQuantityUpdated] = useState(false);
	useEffect(() => {
		let width = window.innerWidth;
		if (width > 600 && width < 800) {
			setProductsPerRow(3);
		} else if (width <= 800) {
			setProductsPerRow(2);
		} else if (width > 800 && width < 1366) {
			setProductsPerRow(3);
		} else {
			setProductsPerRow(4);
		}
	}, [window.innerWidth]);
	useEffect(() => {
		setCategoriesArray([
			{
				category: metaData && metaData.categories && metaData.categories[0],
				products: metaData && metaData.products,
				rows: 1,
			},
		]);
	}, [metaData]);

	useEffect(() => {
		if (
			categoriesProductsArray &&
			categoriesProductsArray.length &&
			categoriesProductsArray[0] !== undefined
		) {
			setCategoriesArray(categoriesProductsArray);
		}
	}, [categoriesProductsArray]);

	const showMore = (category) => {
		setQuantityUpdated(true);
		saveStateSession(
			'FF-topProducts-counter',
			Number(loadStateSession('FF-topProducts-counter')) + 1
		);
		setCategoriesArray((prevCategoriesArray) => {
			return prevCategoriesArray.map((item) => {
				if (item.category === category) {
					return { ...item, rows: item.rows + 1 }; // Update rows for the matching category
				}
				return item;
			});
		});
	};
	const showLess = (category) => {
		setQuantityUpdated(true);
		saveStateSession(
			'FF-topProducts-counter',
			Number(loadStateSession('FF-topProducts-counter')) - 1
		);
		setCategoriesArray((prevCategoriesArray) => {
			return prevCategoriesArray.map((item) => {
				if (item.category === category) {
					return { ...item, rows: item.rows - 1 }; // Update rows for the matching category
				}
				return item;
			});
		});
	};
	const displaySymbol = (currencyCode) => {
		return getCurrencySymbol(currencyCode);
	};

	useEffect(() => {
		if (categoriesArray.length && !quantityUpdated) {
			let array = [];
			categoriesArray.map((category, categoryIndex) => {
				let productIdsArray =
					category &&
					category.products &&
					category.products.map((eachItem) => {
						return eachItem.product_id;
					});
				let stringifyProductIDs = String(productIdsArray);

				stringifyProductIDs &&
					stringifyProductIDs !== 'undefined' &&
					stringifyProductIDs !== 'false' &&
					Axios.get(
						`${window['BASE_URL']
						}/shop/${tenantId}/products/price?productIds=${stringifyProductIDs}&country=${loadStateSession(
							'FS-countryCode'
						)}`,
						{
							headers: {
								'x-tenant-id': tenantId,
								Authorization: `Bearer ${token}`,
							},
						}
					).then((resp: any) => {
						let response = resp.data.response;
						let products = response.data.products;
						let categoryWithResp = {
							category: category.category,
							products: products,
						};

						array.push(categoryWithResp);
						if (categoryIndex === categoriesArray.length - 1) {
							let finalArray = [...array];
							setCategoriesLLMArray(finalArray);
						}
					});
			});
		}
	}, [categoriesArray]);

	const handleProductDetails = (productId) => {
		setReasonData('');

		Axios.get(
			window['BASE_URL'] + `/conversation/tenant/${tenantId}/bot/${botId}/recommendation_rational?text=${queryText}&conversation_id=${conversationId}&message_id=${messageId}&productId=${productId}`,
			{
				headers: {
					'Authorization': `Bearer ${loadStateSession('token')}`,
					'x-tenant-id': loadStateSession('tenantId') || loadStateSession('tenantID')
				}
			}

		).then((response) => {
			setReasonData(response.data.products[0].reason);
			// setReasonQuery('')
		});
	};
	useEffect(() => {
		setEcomCategories(metaData && metaData.categories);
		//	handleProductDetails();
		setReasonData('');
	}, [metaData]);
	const productSelection = (product) => {
		setSelectedProduct(
			product.product_id === selectedProduct ? null : product.product_id
		);
		saveStateSession('FF-productID', product.product_id);
		saveStateSession('FF-productName', product.title);
		showBack();
		showCartData();
		setSelectedProductID(product.product_id);
	};
	const styleSelection = (product) => {
		setSelectedProduct(
			product.productId === selectedProduct ? null : product.productId
		);
		saveStateSession('FF-productID', product.productId);
		saveStateSession('FF-productName', product.title);
		showBack();
		showCartData();
		setSelectedProductID(product.productId);
	};
	const EcomProductList = (page: string = '') => {
		return (
			<div className='ecom-product-list'>

				<div className='list-of-products'>
					{ecomCategories &&
						ecomCategories.map((category, categoryIndex) => {
							let indexOfProduct = categoriesArray.findIndex((item) => {
								return item.category === category;
							});

							if (categoriesArray[indexOfProduct]) {
								return (
									<>
										{categoryIndex !== 0 && (
											<div className='category'>
												{categoriesArray[indexOfProduct] &&
													categoriesArray[indexOfProduct].products.length >= 1 ? (
													<p>{category}</p>
												) : null}
											</div>
										)}
										{Array.from(
											{
												length:
													category === categoriesArray[indexOfProduct].category
														? categoriesArray[indexOfProduct].rows
														: 1,
											},
											(_, rowIndex) => (
												<div className='product-row' key={rowIndex}>
													{categoriesArray[indexOfProduct] &&
														categoriesArray[indexOfProduct].products
															.filter((product) =>
																page === 'ecom cart'
																	? categoryIndex !== 0 &&
																	product.category === category
																	: product.category === category
															)
															.slice(
																rowIndex * productsPerRow,
																(rowIndex + 1) * productsPerRow
															)
															.map((product, index) => {
																let llmMatchedProduct: any = [];
																let price = product.price;
																let currency = product.currency;
																let imageOnHover = product.imageUrl;
																let sale_price = product.sale_price;
																if (categoriesLLMArray.length) {
																	llmMatchedProduct = categoriesLLMArray.length
																		? categoriesLLMArray[indexOfProduct] &&
																		categoriesLLMArray[
																			indexOfProduct
																		].products.filter(
																			(v) => v.id === product.product_id
																		)
																		: '';
																	if (
																		llmMatchedProduct &&
																		llmMatchedProduct.length
																	) {
																		price =
																			llmMatchedProduct &&
																			llmMatchedProduct[0].price;

																		currency =
																			llmMatchedProduct &&
																			llmMatchedProduct[0].currency;
																		imageOnHover = llmMatchedProduct[0].images
																			.length
																			? llmMatchedProduct[0].images[1]
																				? llmMatchedProduct[0].images[1] ===
																					product.imageUrl
																					? llmMatchedProduct[0].images[0]
																					: llmMatchedProduct[0].images[1]
																				: product.imageUrl
																			: product.imageUrl;
																		sale_price =
																			llmMatchedProduct &&
																			llmMatchedProduct[0].sale_price;
																	}
																}
																let showDiscount =
																	product.category.toLowerCase() ===
																		'best deals'
																		? true
																		: false;
																return (
																	<div
																		className={`product ${product.product_id === selectedProduct
																			? 'selected'
																			: ''
																			}`}
																		key={index}
																		onClick={() => {
																			productSelection(product),
																				setCategory(product.category);
																			handleProductDetails(product.product_id)
																		}}
																	>
																		<EcomCard
																			selectedProduct={
																				product.product_id === selectedProduct
																			}
																			key={index}
																			title={product.title}
																			price={price}
																			currency={displaySymbol(currency)}
																			header={product.header}
																			mediaType={'image'}
																			mediaLink={product.imageUrl}
																			imageOnHover={imageOnHover}
																			showDiscount={showDiscount}
																			colorMode={colorMode}
																			sale_price={sale_price}
																		/>
																	</div>
																);
															})}
												</div>
											)
										)}
										{page !== 'ecom cart' ? (
											<div className='view-products'>
												{(category === categoriesArray[indexOfProduct].category
													? categoriesArray[indexOfProduct].rows
													: 1) *
													productsPerRow <
													(categoriesArray &&
														categoriesArray[indexOfProduct] &&
														categoriesArray[indexOfProduct].products.filter(
															(product) => product.category === category
														).length) && (
														<div
															className='show-more'
															onClick={() => showMore(category)}
														>
															<svg
																xmlns='http://www.w3.org/2000/svg'
																width='11.478'
																height='7.153'
																viewBox='0 0 11.478 7.153'
															>
																<path
																	id='Path_20566'
																	data-name='Path 20566'
																	d='M15425.4,681.9l5.032,5.032,5.031-5.032'
																	transform='translate(-15424.696 -681.194)'
																	fill='none'
																	stroke-width='2'
																/>
															</svg>
															<p>View More</p>
														</div>
													)}
												{categoriesArray[indexOfProduct] &&
													categoriesArray[indexOfProduct].rows > 1 && (
														<div
															className='show-less'
															onClick={() => showLess(category)}
														>
															<svg
																xmlns='http://www.w3.org/2000/svg'
																width='11.478'
																height='7.153'
																viewBox='0 0 11.478 7.153'
															>
																<path
																	id='Path_20566'
																	data-name='Path 20566'
																	d='M15425.4,686.933l5.032-5.032,5.031,5.032'
																	transform='translate(-15424.696 -680.487)'
																	fill='none'
																	stroke-width='2'
																/>
															</svg>
															<p>View Less</p>
														</div>
													)}
											</div>
										) : null}
									</>
								);
							} else {
								null;
							}
						})}
				</div>
			</div>
		);
	};

	return (
		<EcomChatDiv colorMode={colorMode} className='ff-ecom-chats'>
			<div className='filter-message-time-holder'>
				<div className='message-time'>
					<div
						className='message'
						dangerouslySetInnerHTML={{ __html: message }}
					></div>

					{message !=
						"Couldn't connect to the server. Please Retry. If the issue persist check your connection and try again later." ? (
						<div className='ff-ecom-feedback'>
							<MessageFeedback
								messageType={'server'}
								timeStamp={time}
								popUpSnackBar={popUpSnackBar}
								openThumbsPopup={openThumbsPopup}
								thumbFilledUp={thumbFilledUp}
								handleSubmit={handleSubmit}
								showFeedbackIcons={true}
								messageId={messageId}
								data={''}
							/>
						</div>
					) : null}
				</div>
			</div>
			{showCart ? (
				<EcomCartItem
					topProductID={topProductID}
					onClose={onClose}
					staticDetailsURL={staticDetailsURL}
					enableStyleAdvisor={enableStyleAdvisor}
					advisorTitle={advisorTitle}
					selectedProductID={selectedProductID}
					category={category}
					handleSubmit={handleSubmit}
					getTitleMessage={getTitleMessage}
					reasonQuestion={reasonData}
					// category={category}
					styleAdvisorCache={styleAdvisorCache}
					styleAdvisor={styleAdvisor}
					handleStyleAdvisor={handleStyleAdvisor}
					setSelectedProductData={setSelectedProductData}
					tenantId={tenantId}
					token={token}
					conversationId={responseId}
					reasonData={reasonData}
					onClickStyleAdvisor={(product) => {
						storeStyle();
						setTimeout(() => {
							styleSelection(product), setCategory('You may also like');
						}, 100);
					}}
					products={metaData.products}
					ecom={
						<EcomChatDiv
							colorMode={colorMode}
							visibleRows={1}
							className='ff-ecom-chats ff-ecom-cart-chat'
						>
							{EcomProductList('ecom cart')}
						</EcomChatDiv>
					}
				/>
			) : (
				<>{EcomProductList()}</>
			)}
		</EcomChatDiv>
	);
};

export default EcomChats;
